export default __webpack_public_path__ + "static/media/goopter-use-case-retail-stores.72243c2e.jpg";